import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';
import { isZoover } from '@vakantiesnl/components/src/utils';

const FILTERS_DESKTOP_NAV_WIDTH = '320px';

export const useStyles = makeStyles<{
	scrollDirection: 'up' | 'down' | null;
}>()((theme, { scrollDirection }) => ({
	container: {
		display: 'flex',
		justifyItems: 'stretch',
		position: 'relative',
		gap: theme.spacing.medium,
	},
	mainContainer: {
		marginTop: theme.spacing.small,
	},
	breadCrumbsContainer: {
		marginBottom: theme.spacing.small,
	},
	brandedSearchCards: {
		margin: 0,
	},
	brandedSearchCardsContent: {
		padding: 0,
	},
	filtersContainer: {
		top: '100%',
		left: 0,
		height: '100%',
		position: 'fixed',
		zIndex: theme.zIndex.raised,
		width: '100%',
		background: theme.palette.neutral[0],
		padding: `0 ${theme.spacing.small}`,

		[getFromBreakpoint('lg')]: {
			zIndex: theme.zIndex.default,
			padding: 0,
			minWidth: FILTERS_DESKTOP_NAV_WIDTH,
			maxWidth: FILTERS_DESKTOP_NAV_WIDTH,
			position: 'relative',
			transition: 'top 1s cubic-bezier(0.23, 1, 0.32, 1)',
		},
	},
	divider: {
		margin: `${theme.spacing.small} 0`,

		[getFromBreakpoint('lg')]: {
			margin: `${theme.spacing.medium} 0`,
		},
	},
	filtersContainerVisible: {
		top: 0,
	},
	resultsContainer: {
		flex: '1 1 100%',
		display: 'flex',
		flexFlow: 'column nowrap',
		top: 0,
		maxWidth: '100%',
		position: 'static',

		[getFromBreakpoint('lg')]: {
			position: 'sticky',
			maxWidth: `calc(100% - (${FILTERS_DESKTOP_NAV_WIDTH} + ${theme.spacing.medium}))`,
		},
	},
	fullWidth: {
		maxWidth: '100%',
	},
	partyPickerFilterBarContainer: {
		/** Only add navbar height for zoover because the nav on vakanties is not sticky (yet) */
		top: scrollDirection === 'up' && isZoover ? theme.navbar.height : '0px',
		transitionProperty: 'top',
		transitionTimingFunction: theme.animation.curve.easeInOut,
		transitionDuration: theme.animation.duration.long,
		background: theme.palette.neutral[0],
		padding: `${theme.spacing.xxsmall} ${theme.spacing.small}`,
		width: '100%',
		marginLeft: `calc(${theme.spacing.small} * -1)`,
		position: 'sticky',
		marginBottom: 0,
	},
	observeElement: {
		width: 0,
		height: 0,
	},
	shadow: {
		boxShadow: theme.elevation.top.raised,
		zIndex: theme.zIndex.raised,
	},
	filtersControlsWrapper: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
}));
